import React from 'react';
import Button from 'components/ButtonDeprecated';
import Image from 'components/Image';
import Link from 'components/Link';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';
import CoachingConstants from 'coaching/CoachingConstants';
import RemindCoachingLogoLight from 'assets/images/coaching/coaching_logo_light.svg';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';

import 'coaching/components/styles/CoachingHelpHeader.scss';

type Props = {
  showLoginButton?: boolean;
  firstName?: string;
  lastName?: string;
};

export default function CoachingHelpHeader({
  showLoginButton = false,
  firstName,
  lastName,
}: Props) {
  const logInCopy = userAgent.isDesktop() ? 'Log in for personalized help' : 'Log in';
  const displayName = [firstName, lastName].join(' ').trim();

  return (
    <div className="CoachingHelpHeader">
      <MediaObject figure="right" className="CoachingHelpHeader-top" center>
        <div className="CoachingHelpHeader-left">
          <Link to={CoachingConstants.COACHING_HELP_ROUTE}>
            <Image width={174} src={RemindCoachingLogoLight} />
          </Link>
        </div>
        {showLoginButton ? (
          <Button color="whiteout" level="secondary" to="/log_in">
            {logInCopy}
          </Button>
        ) : (
          !!displayName && <Text color="whiteout">{displayName}</Text>
        )}
      </MediaObject>
    </div>
  );
}
